import myImage from '../src/Images/couch.png'
import About from './About';
import Product from './Product';
import Services from './Services';
import Testimonial from './Testimonial';
import Blog from './Blog';


const Home = () =>{
    return(
        <div>
            {/* Start Hero Section */}
			<div class="hero">
				<div class="container">
					<div class="row justify-content-between">
						<div class="col-12 col-lg-5 ">
							<div class="intro-excerpt">
								<h1>Modern Interior <span clsas="d-block">Design Studio</span></h1>
								<p class="mb-4">Donec vitae odio quis nisl dapibus malesuada. Nullam ac aliquet velit. Aliquam vulputate velit imperdiet dolor tempor tristique.</p>
								<p><a href="" class="btn btn-secondary me-2">Shop Now</a><a href="#" class="btn btn-white-outline">Explore</a></p>
							</div>
						</div>
						<div class="col-12 col-lg-7">
							<div class="hero-img-wrap">
								<img src={myImage} class="img-fluid"/>
							</div>
						</div>
					</div>
				</div>
			</div>
		{/* <!-- End Hero Section --*/}
        <Product/>
        <About/>
        <Services/>
        <Testimonial/>
        <Blog/>
		
        </div>
    )
}

export default Home;